<template>
  <div>
    <v-layout row wrap>
        <v-menu
            :disabled="disabled"
            v-model="menuStart"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                v-model="date"
                :label="plabel"
                persistent-hint
                prepend-icon="mdi-calendar"
                :disabled="disabled"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="rules"
                ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title  @input="onChangeDate"></v-date-picker>
        </v-menu>
    </v-layout>
  </div>
</template>

<script>
export default {
    props: {
        value: String,
        plabel: String,
        rules: Array,
        disabled: Boolean
    },
    data() {
        return {
            date: '',
            menuStart: false
        };
    },
    watch: {
        value() {
            this.date = this.value;
        }
    },
    methods: {
        onChangeDate() {
            this.$emit('onChangeDate', this.date);
            this.menuStart = false;
        }
    }
}
</script>